// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/';
const ROOTS_HAM = '/ham';
const ROOTS_CONFIGURATIONS = '/configurations';
const ROOTS_BASIC_DATA = '/basicdata';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login')
};

export const PATH_PAGE = {
  about: '/about-us',
  contact: '/contact-us',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
};

export const PATH_HAM = {
  root: ROOTS_HAM,
  Dashboard: path(ROOTS_HAM, '/Dashboard'),
  Entries: path(ROOTS_HAM, '/Entries'),
  HamSettings: path(ROOTS_HAM, '/Settings'),
  Hamapproval: path(ROOTS_HAM, '/HamApproval'),
  Orderapproval: path(ROOTS_HAM, '/OrderApproval')
};

export const PATH_SETTINGS = {
  root: ROOTS_CONFIGURATIONS,
  Comapany: path(ROOTS_CONFIGURATIONS, '/Company'),
  Notification: path(ROOTS_CONFIGURATIONS, '/Notification'),
  IdmEmailTemplate: path(ROOTS_CONFIGURATIONS, '/IdmEmailTemplate')
};

export const PATH_BASIC_DATA = {
  root: ROOTS_BASIC_DATA,
  FileImport: path(ROOTS_BASIC_DATA, '/FileImport'),
  QuoteEquipment: path(ROOTS_BASIC_DATA, '/QuoteEquipment')
};